// libs
import { connect } from 'react-redux';

// redux selectors
import {
  getProductUrl,
  getProductSKU,
  getReviewSummary,
  getBreadCrumbs,
} from 'shared/store/details/selectors';

// components
import MetaInfo from './MetaInfo';

const mapStateToProps = (state: any) => ({
  actionUrl: getProductUrl(state),
  SKU: getProductSKU(state),
  review: getReviewSummary(state),
  breadCrumbs: getBreadCrumbs(state),
});

export default connect(mapStateToProps)(MetaInfo);
